import appStore from 'redux/stores/app.store';
import DateTimeUtils from 'utils/DateTimeUtils';
import { APP_EVENT_NAMES } from './network.const';

type NetworkEventListener = () => void;

function _subscribeNetworkEvent(
  eventType: 'error' | 'success',
  callback: NetworkEventListener,
): () => void {
  const eventName =
    eventType === 'error'
      ? APP_EVENT_NAMES.NETWORK_ERROR
      : APP_EVENT_NAMES.NETWORK_SUCCESS;

  window.addEventListener(eventName, callback);

  return () => {
    window.removeEventListener(eventName, callback);
  };
}

export const subscribeNetworkError = (callback: NetworkEventListener) =>
  _subscribeNetworkEvent('error', callback);

export const subscribeNetworkSuccess = (callback: NetworkEventListener) =>
  _subscribeNetworkEvent('success', callback);

export const publishNetworkError = (): void => {
  window.dispatchEvent(new CustomEvent(APP_EVENT_NAMES.NETWORK_ERROR));
};

export const publishNetworkSuccess = (): void => {
  window.dispatchEvent(new CustomEvent(APP_EVENT_NAMES.NETWORK_SUCCESS));
};

export function getCurrentDateTime(): string {
  const tz = appStore.getTz();
  return DateTimeUtils.getISONow(tz);
}
